import { defineMessages } from 'react-intl';

export default defineMessages({
  folderNature: {
    id: 'amc_details.my_requests.folder_nature',
  },
  requestDate: {
    id: 'amc_details.my_requests.request_date',
  },
  expensesIncurred: {
    id: 'amc_details.my_requests.expenses_incurred',
  },
  folderReference: {
    id: 'amc_details.my_requests.folder_reference',
  },
  status: {
    id: 'amc_details.my_requests.status',
  },
  statusCreated: {
    id: 'amc_details.my_requests.created_status',
  },
  statusValidated: {
    id: 'amc_details.my_requests.validated_status',
  },
  statusRejected: {
    id: 'amc_details.my_requests.rejected_status',
  },
});
